module.exports = __webpack_public_path__ + "img/measurements_icon.0aba778d.svg";